import * as ZXing from "@zxing/library/umd/index.min.js";

export default ZXing;
